import { Grid, IconButton, Typography } from "@material-ui/core";
import { ArrowBackRounded, ArrowForwardRounded } from "@material-ui/icons";
import "./styles.scss";

interface ItemNavProps {
  index: number;
  setIndex: (i: number) => void;
  label?: string;
  length: number;
}
const ItemNav = ({ index, setIndex, label = "Question", length }: ItemNavProps) =>
  length ? (
    <Grid container sm={3} item xs={5} justifyContent="space-between">
      <IconButton onClick={() => setIndex(index - 1)} className="navButton" disabled={index === 0}>
        <ArrowBackRounded />
      </IconButton>
      <Typography variant="subtitle2">
        {label} {index + 1} / {length}
      </Typography>
      <IconButton onClick={() => setIndex(index + 1)} className="navButton" disabled={index + 1 === length}>
        <ArrowForwardRounded />
      </IconButton>
    </Grid>
  ) : null;

export default ItemNav;
